import { render, staticRenderFns } from "./LabelLayoutSelect.vue?vue&type=template&id=40db1c44&scoped=true"
import script from "./LabelLayoutSelect.vue?vue&type=script&lang=ts"
export * from "./LabelLayoutSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db1c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40db1c44')) {
      api.createRecord('40db1c44', component.options)
    } else {
      api.reload('40db1c44', component.options)
    }
    module.hot.accept("./LabelLayoutSelect.vue?vue&type=template&id=40db1c44&scoped=true", function () {
      api.rerender('40db1c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout/LabelLayoutSelect.vue"
export default component.exports